import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const tapsForwardConfig = {
    name: 'kpi.instagram.stories.stories_taps_forward',
    id: 'stories_taps_forward',
    icon: {
        name: 'chevron-right',
        style: colors.aquablue
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
